import { AppConfig } from 'src/configuration';
import * as Sentry from '@sentry/browser';

AppConfig.env.SENTRY_ON && Sentry.init({
  dsn: AppConfig.env.SENTRY_DSN,
  // Not RAILS_ENV: the deployed image bakes RAILS_ENV=production on both
  // beunity.app and test.beunity.app. The server resolves the real tag.
  environment: AppConfig.env.SENTRY_ENVIRONMENT || AppConfig.env.RAILS_ENV,
  release: AppConfig.env.SENTRY_RELEASE,
  // debug: true, // turn this on for debugging...
  ignoreErrors: [/ResizeObserver loop completed with undelivered notifications/, /\[PUSHER CUSTOM\]/],
  // No tracesSampleRate: @sentry/browser v8 only emits page-load/navigation/request
  // traces via browserTracingIntegration(), which we deliberately don't load — so a
  // sample rate would throttle a stream that is never produced. Add the integration
  // first if browser traces are ever wanted.
  maxValueLength: 2048, // default is 250, but we might need to see more of the exception string, max is 8192
  attachStacktrace: true,
  maxBreadcrumbs: 100,
  integrations: [
    // Attaches global handlers to capture uncaught exceptions and unhandled rejections.
    Sentry.globalHandlersIntegration({ onunhandledrejection: false }),
    // Send console.error to Sentry
    Sentry.captureConsoleIntegration({ levels: ['error'] }),
  ],
  beforeSend(event) {
    const appVersion = AppConfig.runtime.mobile_app_version;

    Sentry.setTags({
      ...(appVersion && { appVersion }),
    });

    Sentry.setUser({ id: AppConfig.user.id });

    return event;
  },
});
